/**
 * @selector [data-js-checkboxCard]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';

export default class Oboarding extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;
        this.$el = $(element);

        this.$link = this.$el.find('[data-js-checkboxCard-link]');

        this.changeLink();

        console.log(this.$link);

        this.bindListeners();

        return this;
    }

    bindListeners() {
        this.on('change', this.onChangeEvent);
    }

    onChangeEvent(e) {
        e.preventDefault();

        this.changeLink();

        // this.changeTotal();
    }

    changeLink() {
        const formParams = new URLSearchParams(new FormData(this.el));

        const baseUrl = this.$link.attr('data-base-url');
        this.$link.attr('href', `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${formParams.toString()}`);
    }
}
